<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ targetid }}:{{ point_block_obj }}
    <hr />
    {{ targetid }}:{{ point_block_obj_list_attach }} -->
    <div class="w100 mb-4">
      <div class="row mb-3">
        <div class="col-9">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            v-model="prom_cond_obj.label"
            class="form-control"
          />
        </div>
        <div class="col-3">
          <label for="SportsYear" class="form-label">sort</label>
          <input
            type="number"
            v-model="prom_cond_obj.sort"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <h5>ランキング抽出条件</h5>
    <div class="w100 mb-4">
      <div class="row mb-3">
        <div class="col-3">
          <label for="SportsYear" class="form-label">年度</label>
          <bs-select
            :options="sports_year_list"
            v-model="prom_cond_obj.sports_year"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-3">
          <label for="LicenseEventCd" class="form-label">競技</label>
          <bs-select
            :options="license_event_cd_obj_list"
            v-model="prom_cond_obj.license_event_id"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-6">
          <div for="PromCondSettingType" class="form-label">集計単位</div>
          <div>
            <p
              class="alert alert-warning"
              v-if="chk_promotion_setting_type(20)"
            >
              集計ブロック毎に設定を行います。
            </p>
            <p
              class="alert alert-warning"
              v-else-if="chk_promotion_setting_type(10)"
            >
              シリーズを絞り込み、クラス毎に設定を行います。
            </p>
          </div>
        </div>
        <!-- <div class="col-3">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="prom_cond_obj.sort"
          />
        </div> -->
      </div>
      <div class="accordion mb-3" id="accordion_FilterItem">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRaceTypeCd"
              aria-expanded="true"
              aria-controls="collapseRaceTypeCd"
            >
              格式を絞り込む
            </button>
          </h2>
          <div id="collapseRaceTypeCd" class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div class="">
                <p class="alert alert-sm alert-warning">
                  格式を複数選択した場合、そのいずれかに一致するシリーズから検索されます。<br />
                  選択しない場合はすべての格式から検索されます。
                </p>
              </div>
              <div class="">
                <div
                  class="d-inline-block mb-1 me-2"
                  v-for="race_type in race_type_cd_obj_list"
                  :key="race_type"
                >
                  <button
                    :class="attach_obj_class(race_type.id, 'race_type_cd')"
                    @click="input_check_obj(race_type.id, 'race_type_cd')"
                  >
                    <i
                      class="bi bi-check-square"
                      v-if="attach_obj(race_type.id, 'race_type_cd')"
                    ></i>
                    <i class="bi bi-square" v-else></i> {{ race_type.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRegion"
              aria-expanded="true"
              aria-controls="collapseRegion"
            >
              集計ブロックマスタから絞り込む
            </button>
          </h2>
          <div id="collapseRegion" class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div class="">
                <p class="alert alert-sm alert-warning">
                  集計ブロックマスタを複数選択した場合、そのいずれかに一致するレースイベントから検索されます。<br />
                  選択しない場合は集計ブロックマスタの絞り込みを行いません。
                </p>
              </div>
              <div class="">
                <div
                  class="d-inline-block mb-1 me-2"
                  v-for="point_block in point_block_obj_list"
                  :key="point_block"
                >
                  <button
                    :class="attach_obj_class(point_block.id, 'point_block')"
                    @click="input_check_obj(point_block.id, 'point_block')"
                  >
                    <i
                      class="bi bi-check-square"
                      v-if="attach_obj(point_block.id, 'point_block')"
                    ></i>
                    <i class="bi bi-square" v-else></i> {{ point_block.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseLimit"
              aria-expanded="true"
              aria-controls="collapseLimit"
            >
              有効戦数を設定する
            </button>
          </h2>
          <div id="collapseLimit" class="accordion-collapse collapse show">
            <div class="accordion-body">
              <div class="">
                <p class="alert alert-sm alert-warning">
                  有効戦数を選択した場合、成績結果上位順にその戦数分のポイントを集計します。
                </p>
              </div>
              <div class="">
                <bs-select
                  :options="effective_num_list"
                  v-model="prom_cond_obj.effective_num"
                  :null-option="false"
                  :classParam="'form-select'"
                ></bs-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5>昇降格設定</h5>
      <div class="row mb-3" v-if="prom_cond_obj.license_event_id">
        <div class="col-4">
          <label for="Label" class="form-label">昇格前ライセンス</label>
          <bs-select
            :options="license_cd_filter_category(1)"
            v-model="prom_cond_obj.before_license_id"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-4">
          <label for="Label" class="form-label">昇格後ライセンス</label>
          <bs-select
            :options="license_cd_filter_category(1)"
            v-model="prom_cond_obj.after_license_id"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-3">
          <div for="PromType" class="form-label">昇降格種別</div>
          <bs-select
            :options="rank_promotion_type_select_list"
            v-model="prom_cond_obj.promotion_type"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
      </div>

      <div class="row mb-3" v-if="chk_promotion_setting_type(20)">
        <h5>集計ブロック</h5>
        <div class="col-12 mb-2">
          <p class="alert alert-warning">
            集計ブロック毎にランキング上位人数およびポイント、もしくはその両方を設定して下さい。
          </p>
        </div>
        <div class="col-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 50%">ブロック名</th>
                <th>上位</th>
                <th>ポイント</th>
                <th>設定</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="point_block in point_block_obj_list_attach"
                :key="point_block"
              >
                <td>
                  {{ (point_block || {}).label }}
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="point_block.rank_higher"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="point_block.point_higher"
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    class="form-control"
                    v-model="point_block.include_same_rank"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mb-3" v-if="chk_promotion_setting_type(10)">
        <h5>シリーズ/クラス設定</h5>
        <div
          class="col-12"
          v-if="
            typeof race_series_cd_obj_list_filter === 'object' &&
            race_series_cd_obj_list_filter.length > 0
          "
        >
          <label for="Label" class="form-label">シリーズ選択</label>
          <bs-select
            :options="race_series_cd_obj_list_filter_plus"
            v-model="filter_series"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div v-else>
          <p class="alert alert-warning">
            指定した条件のシリーズはありません。
          </p>
        </div>
        <div
          class="col-12"
          v-if="
            typeof race_series_cd_obj_list_filter === 'object' &&
            race_series_cd_obj_list_filter.length > 0
          "
        >
          <div
            class="mb-2"
            v-for="race_series in race_series_cd_obj_list_filter_filter"
            :key="race_series"
          >
            <label for="Label" class="form-label">{{
              race_series.label
            }}</label>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 40%">クラス名</th>
                  <th>上位</th>
                  <th>ポイント</th>
                  <th>設定</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="class_data in race_series.class_relation"
                  :key="class_data"
                >
                  <td>
                    {{ (class_data || {}).class_label }}
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model="class_data.rank_higher"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model="class_data.point_higher"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      class="form-control"
                      v-model="class_data.include_same_rank"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import Common from '../../../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'

export default {
  name: 'PromotionCondDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '昇降格条件データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      prom_cond_obj: {},
      promotion_obj: [],
      license_event_cd_obj: [],
      license_cd_obj: [],
      race_type_cd_obj: [],
      race_series_cd_obj: [],
      race_class_data_obj: [],
      region_obj: [],
      point_block_obj: [],

      rank_promotion_type_obj: [],
      rank_promotion_reason_obj: [],
      rank_promotion_result_obj: [],
      filter_item: {
        region: [],
        race_type_cd: [],
        point_block: []
      },
      filter_series: 0,
      class_data_obj_test: [
        {
          id: 1,
          key: 1,
          label: 'ST1000'
        },
        {
          id: 1,
          key: 1,
          label: 'ST600'
        },
        {
          id: 1,
          key: 1,
          label: 'J-GP3'
        },
        {
          id: 1,
          key: 1,
          label: 'JP250'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async input_check_obj(target_id, type) {
      const tmps = { ...this.filter_item }
      if (this.attach_obj(target_id, type) == true) {
        const idx = tmps[type].indexOf(parseInt(target_id))
        tmps[type].splice(idx, 1)
      } else {
        tmps[type].push(parseInt(target_id))
      }
      this.filter_item = tmps
    },
    async loadPromotionCondObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/rank_promotion_cond/lists',
        params
      )
        .then(async response => {
          console.log('loadPromotionCondObj', response)
          this.prom_cond_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.prom_cond_obj = {}
        })
        .finally(async () => {
          await this.setPromotionCondOptions()
          await this.setPromotionCondItems()
          this.$forceUpdate()
        })
    },
    async setPromotionCondItems() {
      const series_tmp = [...this.race_series_cd_obj]
      const tmps = series_tmp.map(series => {
        if (
          typeof this.prom_cond_obj === 'object' &&
          typeof this.prom_cond_obj.items === 'object' &&
          this.prom_cond_obj.items.find(item => item.series_id == series.id) &&
          typeof series.class_relation === 'object'
        ) {
          series.class_relation.map(relation => {
            if (
              this.prom_cond_obj.items.find(
                item =>
                  item.class_id == relation.class_id &&
                  item.series_id == series.id
              )
            ) {
              const item = this.prom_cond_obj.items.find(
                item =>
                  item.class_id == relation.class_id &&
                  item.series_id == series.id
              )
              relation.point_higher = item.point_higher
              relation.rank_higher = item.rank_higher
              relation.include_same_rank = item.include_same_rank
            }
          })
        }

        return series
      })

      this.race_series_cd_obj = tmps
      // if (typeof this.prom_cond_obj === 'object' && typeof this.prom_cond_obj.items === 'object') {
      // }
    },
    async setPromotionCondOptions() {
      if (
        typeof this.prom_cond_obj === 'object' &&
        typeof this.prom_cond_obj.options === 'object'
      ) {
        this.filter_item.race_type_cd = []
        this.filter_item.point_block = []
        console.log('setPromotionCondOptions', this.prom_cond_obj)
        await Promise.all(
          this.prom_cond_obj.options.map(async option => {
            console.log('setPromotionCondOptions option', option)
            if (parseInt(option.race_type_id) > 0) {
              await this.input_check_obj(
                parseInt(option.race_type_id),
                'race_type_cd'
              )
            }
            if (parseInt(option.point_block) > 0) {
              await this.input_check_obj(
                parseInt(option.point_block),
                'point_block'
              )
            }
          })
        )
      }
    },
    async loadPromotionList() {
      const params = {}
      params['stat'] = [1]
      // if (this.sprm.category_id)
      //   params['category_id'] = this.sprm.category_id;
      params['pagelimit'] = this.page_limit
      if (this.page >= 0) params['p'] = this.page
      // params['pageorder'] = 'mfj_rank_promotion_data.sort';
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'member'
      })
      await this.basicPosts_S(
        config.BASE_API_URL + '/rank_promotion/lists',
        params
      )
        .then(async response => {
          console.log('loadPromotionList response', response)
          this.promotion_obj =
            response.data && response.data.body ? response.data.body : []
          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'promotion'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'promotion'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.promotion_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceSeriesCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_series_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceSeriesCdList response', response)
          const tmps =
            response.data && response.data.body ? response.data.body : []
          this.race_series_cd_obj = tmps.map(tmp => {
            if (typeof tmp.class_relation === 'object') {
              tmp.class_relation = tmp.class_relation.map(rel => {
                rel['point_higher'] = this.get_item_series_class_param(
                  tmp.id,
                  rel.class_id,
                  'point_higher'
                )
                rel['rank_higher'] = this.get_item_series_class_param(
                  tmp.id,
                  rel.class_id,
                  'rank_higher'
                )
                rel['include_same_rank'] = this.get_item_series_class_param(
                  tmp.id,
                  rel.class_id,
                  'include_same_rank'
                )
                return rel
              })
            }
            return tmp
          })
          // this.race_series_cd_obj =
          //   response.data && response.data.body ? response.data.body : [];
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_series_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceClassDataList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceClassDataList response', response)
          this.race_class_data_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_class_data_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPointBlockList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/point_block/lists',
        params
      )
        .then(async response => {
          console.log('loadPointBlockList response', response)
          const tmps =
            response.data && response.data.body ? response.data.body : []
          this.point_block_obj = tmps.map(tmp => {
            tmp['point_higher'] = 0
            tmp['rank_higher'] = 0
            tmp['include_same_rank'] = false
            return tmp
          })
        })
        .catch(async err => {
          console.log(err)
          this.point_block_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async update() {
      const params = this.prom_cond_obj
      const options_frm = {
        id: 0,
        stat: 1,
        cond_id: 0,
        race_type_id: 0,
        point_block: 0
      }
      const items_frm = {
        id: 0,
        stat: 0,
        cond_id: 0,
        series_id: 0,
        class_id: 0,
        point_block: 0,
        point_higher: 0,
        rank_higher: 0,
        include_same_rank: 0
      }
      // option
      const options = []
      await Promise.all(
        this.filter_item.race_type_cd.map(async race_type_id => {
          if (parseInt(race_type_id) > 0) {
            const option = { ...options_frm }
            option.race_type_id = race_type_id
            options.push(option)
          }
        })
      )
      await Promise.all(
        this.filter_item.point_block.map(async point_block => {
          if (parseInt(point_block) > 0) {
            const option = { ...options_frm }
            option.point_block = point_block
            options.push(option)
          }
        })
      )
      params.options = options

      // items
      const items = []
      // ロード以外
      if (this.chk_promotion_setting_type(20)) {
        await Promise.all(
          this.point_block_obj_list_attach.map(async point_block => {
            if (point_block.point_higher >= 0 || point_block.rank_higher >= 0) {
              const item = { ...items_frm }
              item.point_block = point_block.id
              item.point_higher = point_block.point_higher
              item.rank_higher = point_block.rank_higher
              item.include_same_rank = point_block.include_same_rank ? 1 : 0
              items.push(item)
            }
          })
        )
      } else if (this.chk_promotion_setting_type(10)) {
        console.log('series list', this.race_series_cd_obj_list_filter_filter)
        await Promise.all(
          this.race_series_cd_obj_list_filter_filter.map(async series => {
            console.log('series unit', series)
            if (typeof series.class_relation === 'object') {
              await Promise.all(
                series.class_relation.map(async relation => {
                  if (relation.point_higher >= 0 || relation.rank_higher >= 0) {
                    const item = { ...items_frm }
                    item.point_higher = relation.point_higher
                    item.rank_higher = relation.rank_higher
                    item.series_id = series.id
                    item.class_id = relation.class_id
                    item.include_same_rank = relation.include_same_rank ? 1 : 0
                    items.push(item)
                  }
                })
              )
            }
          })
        )
      }
      // if (this.chk_promotion_setting_type(10)) {
      //   return true;
      // }
      console.log('items', items)
      params.items = items

      const post_url = this.not_add
        ? config.BASE_API_URL + '/rank_promotion_cond/edit/' + this.targetid
        : config.BASE_API_URL + '/rank_promotion_cond/add'
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update rank_promotion_cond response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body.id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.prom_cond_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadPromotionCondObj()
          this.$forceUpdate()
          alert(this.alertMessage + ':' + result + ':' + this.targetid)
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    get_item_point_block: function () {
      const items = this.prom_cond_obj.items
      return function (point_block) {
        console.log(point_block, items)
        // const data = items.find()
        return {
          rank_higher: 0,
          point_higher: 0,
          include_same_rank: 0
        }
      }
    },
    get_item_point_block_param: function () {
      const get_fun = this.get_item_point_block
      return function (point_block, key) {
        const data = get_fun(point_block)
        return data[key]
      }
    },
    get_item_series_class: function () {
      // const items = this.prom_cond_obj.items;
      const prom_cond = this.prom_cond_obj
      console.log('get_item_series_class0 prom_cond', prom_cond)
      return function (series_id, class_id) {
        console.log('get_item_series_class1', series_id, class_id, prom_cond)
        const items = (prom_cond || {}).items
        console.log('get_item_series_class3 items', series_id, class_id, items)
        const param = {
          rank_higher: '',
          point_higher: '',
          include_same_rank: 0
        }
        if (
          typeof items === 'object' &&
          items.find(
            item => item.series_id == series_id && item.class_id == class_id
          )
        ) {
          const tmp_item = items.find(
            item => item.series_id == series_id && item.class_id == class_id
          )
          console.log('get_item_series_class tmp_item', tmp_item)
          param.rank_higher = tmp_item.rank_higher
          param.point_higher = tmp_item.point_higher
          param.include_same_rank = tmp_item.include_same_rank
        }
        return param
      }
    },
    get_item_series_class_param: function () {
      const get_fun = this.get_item_series_class
      return function (series_id, class_id, key) {
        const data = get_fun(series_id, class_id)
        return data[key]
      }
    },
    effective_num_list: function () {
      const tmps = []
      tmps.push({
        key: 0,
        label: '設定しない'
      })
      for (let i = 1; i < 15; i++) {
        tmps.push({
          key: i,
          label: i + '戦分設定する'
        })
      }
      return tmps
    },
    // selectboxで利用(ALL追加)
    race_series_cd_obj_list_filter_plus: function () {
      const tmps = [...this.race_series_cd_obj_list_filter]
      tmps.push({
        id: 0,
        key: 0,
        label: 'ALL'
      })
      return tmps
    },
    // 一覧で仕様
    race_series_cd_obj_list_filter_filter: function () {
      const tmps = [...this.race_series_cd_obj_list_filter]
      if (this.filter_series > 0) {
        return tmps.filter(tmp => tmp.id == this.filter_series)
      } else if (parseInt(this.filter_series) == 0) {
        return tmps
      }
      return []
    },
    race_series_cd_obj_list_filter: function () {
      if (
        this.prom_cond_obj.license_event_id != '' &&
        this.filter_item.race_type_cd.length > 0
      ) {
        return this.race_series_cd_obj_list.filter(race_series => {
          if (
            race_series.license_event_id ==
              this.prom_cond_obj.license_event_id &&
            this.filter_item.race_type_cd.find(selected_race_type => {
              if (
                race_series.type_relation.find(
                  rel_type => rel_type.race_type_id == selected_race_type
                )
              ) {
                return true
              }
            })
          ) {
            return true
          }
          return false
        })
      }
      return this.race_series_cd_obj_list
    },
    chk_promotion_setting_type: function () {
      const license_event =
        typeof this.license_event_cd_obj === 'object'
          ? this.license_event_cd_obj.find(
              license_event_cd =>
                license_event_cd.id == this.prom_cond_obj.license_event_id
            )
          : []
      return function (setting_type) {
        if (
          typeof license_event === 'object' &&
          license_event.rank_promotion_setting_type == setting_type
        ) {
          return true
        }
        return false
      }
    },
    attach_obj: function () {
      const selected = this.filter_item
      return function (target_id, type) {
        if (
          typeof selected === 'object' &&
          typeof selected[type] === 'object' &&
          selected[type].includes(parseInt(target_id)) === true
        ) {
          return true
        }
        return false
      }
    },
    attach_obj_class: function () {
      const attach = this.attach_obj
      return function (target_id, type) {
        if (attach(target_id, type)) {
          return 'btn btn-sm btn-primary'
        }
        return 'btn btn-sm btn-dark'
      }
    },
    sports_year_list: function () {
      const start = 2023
      const nowYear = Common.getNowYear()
      const maxYear = parseInt(nowYear) + 1
      const tmps = []
      for (let i = start; i <= maxYear; i++) {
        tmps.push({
          key: i,
          label: i + '年'
        })
      }
      return tmps
    },
    license_event_cd_obj_list: function () {
      return this.license_event_cd_obj
    },
    license_cd_obj_list: function () {
      return this.license_cd_obj
    },
    license_cd_obj_list_sel_filter: function () {
      if (this.prom_cond_obj.license_event_id) {
        return this.license_cd_obj_list.filter(
          list => list.license_event_cd == this.prom_cond_obj.license_event_id
        )
      } else {
        return this.license_cd_obj_list
      }
    },
    race_type_cd_obj_list: function () {
      return this.race_type_cd_obj
    },
    race_series_cd_obj_list: function () {
      return this.race_series_cd_obj
    },
    race_class_data_obj_list: function () {
      return this.race_class_data_obj
    },
    rank_promotion_type_obj_list: function () {
      return this.rank_promotion_type_obj
    },
    region_obj_list: function () {
      return [...this.region_obj].sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    point_block_obj_list: function () {
      return [...this.point_block_obj].sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    point_block_obj_list_attach: function () {
      const lists = [...this.point_block_obj_list]
        .filter(point_block => {
          if (this.filter_item.point_block.find(fpb => fpb == point_block.id)) {
            return true
          }
          return false
        })
        .map(point_block => {
          if (
            typeof this.prom_cond_obj === 'object' &&
            typeof this.prom_cond_obj.items === 'object' &&
            this.prom_cond_obj.items.length > 0 &&
            this.prom_cond_obj.items.find(
              item => item.point_block > 0 && item.point_block == point_block.id
            )
          ) {
            point_block['point_higher'] = this.prom_cond_obj.items.find(
              item => item.point_block > 0 && item.point_block == point_block.id
            )['point_higher']
            point_block['rank_higher'] = this.prom_cond_obj.items.find(
              item => item.point_block > 0 && item.point_block == point_block.id
            )['rank_higher']
            point_block['include_same_rank'] = this.prom_cond_obj.items.find(
              item => item.point_block > 0 && item.point_block == point_block.id
            )['include_same_rank']
          }
          return point_block
        })
      return lists
    },
    rank_promotion_type_select_list: function () {
      // ここで設定するのは自動、申請(昇降格)の３つ
      const chks = [10, 20, 120]
      return this.rank_promotion_type_obj.filter(type =>
        chks.includes(parseInt(type.key))
      )
    },
    rank_promotion_reason_obj_list: function () {
      return this.rank_promotion_reason_obj
    },
    rank_promotion_result_obj_list: function () {
      return this.rank_promotion_result_obj
    },
    license_cd_map_short_label: function () {
      return this.license_cd_obj_list_sel_filter.map(list => {
        list.label = list.short_label
        return list
      })
    },
    license_cd_filter_category: function () {
      const license_list = this.license_cd_obj_list.filter(license_cd => {
        if (this.prom_cond_obj.license_event_id == '') {
          return true
        } else if (
          this.prom_cond_obj.license_event_id != '' &&
          license_cd.license_event_cd == this.prom_cond_obj.license_event_id
        ) {
          return true
        }
        return false
      })
      return function (category_id) {
        return license_list.filter(
          license_cd => license_cd.license_category == category_id
        )
      }
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    await this.loadRaceTypeCdList()
    await this.loadRaceSeriesCdList()
    await this.loadRaceClassDataList()
    await this.loadPointBlockList()
    await this.loadRegionList()
    await this.loadConfigObj('rank_promotion_type')
    await this.loadConfigObj('rank_promotion_reason')
    await this.loadConfigObj('rank_promotion_result')
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadPromotionCondObj()
      this.btnLabel = '更新'
    } else {
      this.prom_cond_obj = {
        id: 0,
        label: '',
        sports_year: '',
        license_event_id: '',
        effective_num: 0,
        before_license_id: 0,
        after_license_id: 0,
        promotion_type: 0,
        options: [],
        items: [],
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '昇降格データ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
